import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { NewsFilterUI } from './ui';

export class NewsFilter extends PureComponent {
    static displayName = 'NewsFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'newsFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <NewsFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const NewsFilterContainer = compose()(NewsFilter);
